import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	learnMore: {
		id: 'business-list.common.select-edit-error.learn-more',
		defaultMessage: 'Learn more',
		description: 'Link to help docs when the user is not able to edit a field',
	},
});
